var _circle, _circle2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 67,
    viewBox: "0 0 60 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "#EFF1F0"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_370_12782",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 61,
    height: 60
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.8945,
    cy: 30,
    r: 30,
    fill: "#EFF1F0"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_370_12782)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.4218 37.8948C37.6825 37.8948 42.7578 32.9463 42.7578 26.8421C42.7578 20.7379 37.6825 15.7895 31.4218 15.7895C25.1611 15.7895 20.0857 20.7379 20.0857 26.8421C20.0857 32.9463 25.1611 37.8948 31.4218 37.8948Z",
    fill: "#C4C7C6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4218 41.0526C24.3955 41.0526 10.3691 45.2842 10.3691 53.6842V60H52.4744V53.6842C52.4744 45.2842 38.4481 41.0526 31.4218 41.0526Z",
    fill: "#C4C7C6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.bed93f0b2ee7c115089ad47957d7ee18.svg";
export { ForwardRef as ReactComponent };